import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: installments;

  color: ${theme.colors.n400};
`

const blackWeekendStyles = ({ theme, isBlackWeekend }) =>
  isBlackWeekend &&
  css`
    label: installments--black-weekend;
    
    color: ${theme.colors.white};
  `

export const Installments = styled('div')(baseStyles, blackWeekendStyles)
